module.exports = __webpack_public_path__ + "img/vue.3c659bb7.svg";